import { clsx, type ClassValue } from "clsx";
import { textContent } from "domutils";
import { parseDocument } from "htmlparser2";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function minmax(value: number, min: number, max: number) {
  return Math.max(min, Math.min(max, value));
}

export function shuffle<T>(array: T[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1)); // Random index from 0 to i
    [array[i], array[j]] = [array[j], array[i]]; // Swap elements
  }
  return array;
}

export function capitalCase(name: string) {
  const names = name.split(" ");
  return names
    .map((n) => n.charAt(0).toUpperCase() + n.slice(1).toLowerCase())
    .join(" ");
}

export function cleanString(input: string): string {
  const doc = parseDocument(input);
  return textContent(doc) ?? "";
}

export function kebabCase(name: string): string {
  return name
    .normalize("NFD") // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritical marks
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, "-"); // Replace spaces with dashes
}

export function getEmailFromStorage(): string | undefined {
  try {
    const value = localStorage.getItem("cidadao_usr");
    if (!value) return undefined;

    const decoded = atob(value);
    return decoded.includes("@") ? decoded : undefined;
  } catch {
    return undefined;
  }
}
